import React from 'react';
import './StarBackground.css';

export default function StarBackground() {
  return (
    <div className="stars-container">
      <div className="stars"></div>
      <div className="stars2"></div>
      <div className="stars3"></div>
    </div>
  );
}
